// Главная: вход/гость и каталог квестов. «Твой следующий шаг» — по мере появления коллекций и рекомендаций.
import { Link, useNavigate } from 'react-router-dom';
import { useMe } from './state.tsx';
import { Screen, Busy, toast } from './ui.tsx';
import { api } from '../platform/api.ts';
import { t, errText } from '../i18n/index.ts';
import { Catalog } from '../quest/Quest.tsx';

export function Home() {
  const { me, reload } = useMe();
  const nav = useNavigate();
  return (
    <Screen>
      <section className="hero">
        <div className="logo" aria-hidden>🧠</div>
        <h1>{t('app.name')}</h1>
        <p className="muted">{t('app.tagline')}</p>
      </section>

      {me && (
        <section className="stack">
          <h2>{t('home.quests')}</h2>
          <Catalog />
        </section>
      )}

      {!me && (
        <section className="card accent">
          <h2>{t('home.guestTitle')}</h2>
          <p>{t('home.guestText')}</p>
          <div className="row">
            <Busy onClick={async () => { try { await api('auth_guest'); await reload(); } catch (e) { toast(errText(e)); } }}>{t('home.play')}</Busy>
            <button type="button" className="btn ghost" onClick={() => nav('/login')}>{t('home.login')}</button>
          </div>
        </section>
      )}

      {me?.profile.is_guest && (
        <section className="card">
          <p>{t('home.saveProgress')}</p>
          <button type="button" className="btn ghost" onClick={() => nav('/login')}>{t('home.login')}</button>
        </section>
      )}

      {me && <Link className="btn ghost wide" to="/profile">{t('home.profile')}</Link>}
    </Screen>
  );
}
